import { useState } from 'react';

import { useSelector } from 'react-redux';

import FieldComparison
  from '../../../../../../Components/Molecules/Field/FieldComparison/FieldComparison';
import FieldGroupComparison
  from '../../../../../../Components/Molecules/Field/FieldGroupComparison/FieldGroupComparison';
import { defaultLimitSearch } from '../../../../../../Enum/Limit/SearchAdvance';
import { REGEX_CONSTANT } from '../../../../../../Enum/RegexConstant';
import { postPrincipal } from '../../../../../../Fetch/Api/SearchMappingAPI';
import {
  fetchPrincipal,
} from '../../../../../../Fetch/FetchData/SearchMappingData';
import {
  searchMappingActions,
} from '../../../../../../Store/Reducers/SearchMappingReducer';
import {
  DDSonChange,
  DDSOnClick,
  DDSOnScroll,
} from '../../../../../../Utils/Action/DropDownSearch/DropDownSearch';
import {
  fieldRequired,
} from '../../../../../../Utils/Action/Field/FieldRequired';
import {
  IgnorePrincipal,
} from '../../../../../../Utils/Action/Field/IgnorePrincipal';

const FieldPPUDCMappingForm = props => {
  const {t} = props;
  const principal = useSelector(state => state.searchMapping.principal);
  const [filter, setFilter] = useState();
  const [limitation, setLimitation] = useState(defaultLimitSearch);
  const clickSelect = fetch => {
    DDSOnClick(fetch, setLimitation, filter, props.validToken, props.dispatch, props.notify);
  };
  const onScroll = (fetch, prevList) => {
    DDSOnScroll(
      fetch,
      prevList,
      setLimitation,
      limitation,
      filter,
      props.validToken,
      props.dispatch,
      props.notify
    );
  };
  const onChange = async (e, type, fetch, setOption) => {
    DDSonChange(
      e,
      type,
      props.validToken,
      fetch,
      setLimitation,
      setFilter,
      setOption,
      filter,
      props.notify,
      props.dispatch
    );
  };
  const handleRequired = key =>
    fieldRequired(
      props.value(props.mappingForm, "principal_product_user_defined_category_id", "exist"),
      props.value(props.mappingForm, key, "isChecked")
    );
  return (
    <>
      <FieldComparison
        label={t("COMMON:FIELD.PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY_ID")}
        placeholder={t("COMMON:PLACEHOLDER", {
          field: t("COMMON:FIELD.PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY_ID"),
        })}
        typeNew="text"
        typeExist="text"
        nameNew="principal_product_user_defined_category_id"
        valueNew={props.value(
          props.mappingForm,
          "principal_product_user_defined_category_id",
          "new"
        )}
        nameExist="principal_product_user_defined_category_id_exist"
        valueExist={props.value(
          props.mappingForm,
          "principal_product_user_defined_category_id",
          "exist"
        )}
        checked={
          props.value(props.mappingForm, "principal_product_user_defined_category_id", "exist") !==
          null
            ? false
            : props.value(
                props.mappingForm,
                "principal_product_user_defined_category_id",
                "isChecked"
              )
        }
        disabledCheck={
          props.value(props.mappingForm, "principal_product_user_defined_category_id", "exist") !==
          null
            ? true
            : false
        }
        submitMapping={props.submitMapping}
        mappingCode={props.mappingCode}
        onCheck={props.checkedPartial}
        mapping={props.mappingForm}
        dispatch={props.dispatch}
        disabled={true}
      />
      <FieldComparison
        label={t("COMMON:FIELD.CODE")}
        placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.CODE")})}
        typeNew="text"
        typeExist="text"
        nameNew="code"
        valueNew={props.value(props.mappingForm, "code", "new")}
        nameExist="code_exist"
        valueExist={props.value(props.mappingForm, "code", "exist")}
        checked={props.value(props.mappingForm, "code", "isChecked")}
        submitMapping={props.submitMapping}
        mappingCode={props.mappingCode}
        onCheck={props.checkedPartial}
        mapping={props.mappingForm}
        dispatch={props.dispatch}
        pattern={REGEX_CONSTANT.NO_SPACE}
        message={t("COMMON:ERROR.NO_SPACE_SPECIAL", {field: t("COMMON:FIELD.CODE")})}
        required={handleRequired("code")}
      />
      <FieldComparison
        label={t("COMMON:FIELD.CATEGORY_NUMBER")}
        placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.CATEGORY_NUMBER")})}
        typeNew="number"
        typeExist="text"
        nameNew="category_number"
        valueNew={props.value(props.mappingForm, "category_number", "new")}
        nameExist="category_number_exist"
        valueExist={props.value(props.mappingForm, "category_number", "exist")}
        checked={props.value(props.mappingForm, "category_number", "isChecked")}
        submitMapping={props.submitMapping}
        mappingCode={props.mappingCode}
        onCheck={props.checkedPartial}
        mapping={props.mappingForm}
        dispatch={props.dispatch}
        required={handleRequired("category_number")}
      />
      <FieldComparison
        label={t("COMMON:FIELD.VALUE")}
        placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.VALUE")})}
        typeNew="text"
        typeExist="text"
        nameNew="value"
        valueNew={props.value(props.mappingForm, "value", "new")}
        nameExist="value_exist"
        valueExist={props.value(props.mappingForm, "value", "exist")}
        checked={props.value(props.mappingForm, "value", "isChecked")}
        submitMapping={props.submitMapping}
        mappingCode={props.mappingCode}
        onCheck={props.checkedPartial}
        mapping={props.mappingForm}
        dispatch={props.dispatch}
        required={handleRequired("value")}
      />
      <FieldGroupComparison
        label={t("PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY:FIELD.PRINCIPAL")}
        t={t}
        detailDefault={props.detail}
        mapping={props.mappingForm}
        mappingCode={props.mappingCode}
        submitMapping={props.submitMapping}
        option={principal}
        mainKey="principal_id"
        secondKey="principal_name"
        thirdKey="principal_code"
        typeFirst="number"
        typeSecond="text"
        typeThird="text"
        onChange={(e, type) => onChange(e, type, postPrincipal, searchMappingActions.setPrincipal)}
        onClick={() => clickSelect(fetchPrincipal)}
        onScroll={() => onScroll(fetchPrincipal, principal)}
        subLabelOne={"PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY:FIELD.PRINCIPAL_ID"}
        subLabelTwo={"PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY:FIELD.PRINCIPAL_NAME"}
        subLabelThree={"PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY:FIELD.PRINCIPAL_CODE"}
        placeholderThird={t("COMMON:SELECT", {field: t("COMMON:FIELD.PRINCIPAL_CODE")})}
        placeholderSecond={t("COMMON:SELECT", {field: t("COMMON:FIELD.PRINCIPAL_NAME")})}
        placeholderFirst={t("COMMON:SELECT", {field: t("COMMON:FIELD.PRINCIPAL_ID")})}
        valueNew={(key, item) => props.value(props.mappingForm, key, item)}
        onCheck={e => props.checkedPartial(e)}
        dispatch={props.dispatch}
        disabled={IgnorePrincipal(
          props.value(props.mappingForm, "principal_product_user_defined_category_id", "exist")
        )}
        disabledCheck={IgnorePrincipal(
          props.value(props.mappingForm, "principal_product_user_defined_category_id", "exist")
        )}
        required={props.value(props.mappingForm, "principal_id", "exist") !== null ? false : true}
      />
    </>
  );
};

export default FieldPPUDCMappingForm;
